import { Betriebskontakt } from '../../stammdaten/betriebskontakte/betriebskontakt';

export class ScanErgebnis {
    gt_id: number;
    success: boolean;
    abteil: string;
    anzahl_abteil: number;
    anzahl_viehhaendler: number;
    anzahl_tiere_match: number;
    paesse_ohne_tier: number;
    tiere_ohne_pass: number;
    anzahl_tiere: number;
    anzahl_tiere_datensaetze: number;
    ohrmarke_notnull: string;
    ohrmarke_gescannt: number;
    pass_gescannt: number;
    einstallgewicht: number;
    transpondernummer?: string;
    hat_tierreklamation?: number;
    rasse: string;
    geschlecht: string;
    geschlecht_id: number;
    viehhaendler_id?: number;
    viehhaendler_name?: string;
    betriebskontakt_haendler_id?: number;
    betriebskontakt_haendler_name?: string;
    betriebskontaktHaendler?: Betriebskontakt;
    fehler?: string;
    bereits_in_gruppe?: boolean;
    bereitsInGruppe?: boolean;
    importFailed?: boolean;
}

export type EinstallHerkunftFilter = {
    viehhaendlerId?: number;
    betriebskontaktHaendlerId?: number;
};
